import React from 'react'
import ReactDOM from 'react-dom/client'
import AppWithAuthProvider from './AppWithAuthProvider'
import './css/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppWithAuthProvider />
  </React.StrictMode>,
)
